var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckeditor',{ref:"editor",attrs:{"editor":_vm.editor},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }